import styled from 'styled-components';

export const ReuseableFieldNameWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  height: 54px;
`;